import React from "react";
import PropTypes from "prop-types";
import { Avatar, Icon } from "n2-styles";

const AreaDirectorStoreProductsIndex = ({ data }) => {
  const rows = data.map(job => (
    <a key={job.id} className="list-group-item u-hover--raised" href={job.href}>
      <div className="d-flex w-100 align-items-center cursor-pointer row">
        <div className="d-flex flex-column align-content-center mx-3">
          <Avatar user={job.avatar} />
        </div>

        <div className="d-flex flex-column col-4 col-sm-3">
          {job.publication_name}
          <small className="grey-text">{job.territory_name}</small>
        </div>

        <div className="d-none d-sm-flex flex-column grey-text col u-wrap">
          <small>{job.publish_month}</small>
          <small>{job.publish_year}</small>
          <small>{job.nice_status}</small>
        </div>

        <div className="d-none d-sm-flex flex-column grey-text col u-wrap">
          <small>
            {job.page_count}
            {" "}
            Pages
          </small>
          <small>
            Quantity:
            {" "}
            {job.quantity}
            {" "}
          </small>
        </div>

        <div className="d-none d-lg-flex flex-column grey-text col u-wrap">
          <small>
            Shop Order No:
          </small>
          <small>
            {job.order_number}
          </small>
        </div>


        <small className="d-none d-lg-flex flex-column grey-text col-1 u-wrap" title={job.modified_at}>
          {job.formatted_modified_at}
        </small>

        <div className="d-flex grey-text flex-column col-1 align-items-center ml-auto">
          <Icon icon="keyboard_arrow_right" label="See more" />
        </div>
      </div>
    </a>
  ));

  return (
    <ul className="list-group list-group-flush mb-6">
      {rows}
    </ul>
  );
};

AreaDirectorStoreProductsIndex.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    href: PropTypes.string.isRequired,
    avatar: PropTypes.shape.isRequired,
    publication_name: PropTypes.string.isRequired,
    territory_name: PropTypes.string.isRequired,
    publish_month: PropTypes.string.isRequired,
    publish_year: PropTypes.number.isRequired,
    nice_status: PropTypes.string.isRequired,
    page_count: PropTypes.number.isRequired,
    quantity: PropTypes.number.isRequired,
    status: PropTypes.string.isRequired,
    formatted_modified_at: PropTypes.string.isRequired,
    modified_at: PropTypes.string.isRequired,
    order_number: PropTypes.string.isRequired,
  })).isRequired,
};


export default AreaDirectorStoreProductsIndex;
